<template>
  <div>
    <van-popup round style="width: 80%" v-model="showTag" @closed="onClosed">
      <h3 class="header tac fs18 pt10 pb10" v-if="title">{{ title }}</h3>
      <div class="pl15 tac pr15 pt20 pb20 fs14" v-if="message">
        <img :src="icon" v-if="icon" alt="">
        <p class="mt10">{{ message }}</p>
      </div>
      <div class="footer flex pl15 pr15 pb15 pt15">
        <van-button round style="width: 45%" @click="onClick('cancel')">{{ cancelBtnText }}</van-button>
        <van-button type="info" round style="width: 45%" @click="onClick('confirm')">{{ confirmBtnText }}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "confirm",
  components: {},
  data() {
    return {
      title: "",
      message: "",
      icon: '',
      confirmBtnText: "确定",
      cancelBtnText: '取消',
      showTag: false
    }
  },
  methods: {
    open() {
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    },
    onClosed() {
      if (this.remove) this.remove(this.type);
    },
    onClick(type) {
      this.type = type;
      this.close()
    }
  },
}
</script>

<style scoped lang="scss">
.footer {
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/confirm.vue